import {
  Component,
  inject,
  Renderer2,
  type OnDestroy,
  type OnInit,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { credits, currentYear } from '@common/constants';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [RouterModule],
  template: `
    <div class="auth-bg d-flex min-vh-100">
      <div class="row g-0 justify-content-end w-100 m-xxl-5 px-xxl-4 m-3">
        <div
          class="col-xxl-3 col-lg-4 col-md-6 me-lg-5 me-md-5 align-self-center"
        >
          <!-- <app-auth-logo class="mb-2" /> -->
          <!-- <p class="fw-semibold mb-4 text-center text-muted fs-15">Admin Panel Design</p> -->

          <div class="card overflow-hidden text-center  p-xxl-4 p-3 mb-0">
            <router-outlet></router-outlet>
          </div>
          <!-- <p class="mt-4 text-center mb-0">
  {{currentYear}} © OneApp - By <span
    class="fw-bold text-decoration-underline text-uppercase text-reset fs-12">{{credits.name}}</span>
</p> -->
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
  currentYear = currentYear;
  credits = credits;
  private renderer = inject(Renderer2);

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'h-100');
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'h-100');
  }
}
